module.exports = __webpack_public_path__ + "img/77430.f5d8f3bc.svg";